import moment from 'moment'

export default class Permissions {

    constructor() {
        this.rights = {}
        Vue.prototype.$auth.setGetMeHook(this.checkPasswordChange)
    }

    checkPasswordChange(to, from, next) {
        if (to.name == 'change-password') {
            // Don't check if we are already going to this page.
            return true
        }
        if (Vue.prototype.$auth.offline) {
            // No check when offline
            return true
        }
        if (Vue.prototype.$auth.user.source != 'internal') {
            // Password change is only for internal accounts.
            return true
        }
        const duration = parseInt(Vue.prototype.$auth.config.password_lifetime)
        if (!duration) {
            // 0 duration means no max duration.
            return true
        }
        const start = moment(Vue.prototype.$auth.user.password_timestamp)
        const max = start.add(duration, 'd')
        if (moment().diff(max) <= 0) {
            // Password is still valid.
            return true
        }
        next({ name: 'change-password' })
        return false
    }

    setRights(rights) {
        this.rights = rights
    }

    // Rights and permissions primitives.

    hasRight(right) {
        return Vue.prototype.$permissions.rights[right]
    }

    // Permissions regarding the sidebar.
    // We need to define them here and not in the sidebar component
    // because the `sidebar()` function is also used in the navbar.

    sidebar() {
        if (Vue.prototype.$auth.offline) {
            return false
        }
        return Vue.prototype.$permissions.sidebarDashboard()
            || Vue.prototype.$permissions.sidebarAccount()
            || Vue.prototype.$permissions.sidebarTraining()
            || Vue.prototype.$permissions.sidebarSettings()
    }

    sidebarDashboard() {
        return Vue.prototype.$auth.hasPermission('dashboard.access-issues-from-dashboard')
            || Vue.prototype.$auth.hasPermission('dashboard.access-grades-from-dashboard')
    }

    sidebarAccount() {
        return Vue.prototype.$auth.hasPermission('user.manage')
            || Vue.prototype.$auth.hasPermission('user.manage-pilots')
            || Vue.prototype.$auth.hasPermission('user.supervise')
            || Vue.prototype.$auth.hasPermission('cohort.manage')
            || Vue.prototype.$auth.hasPermission('role.manage')
            || Vue.prototype.$auth.hasPermission('entity.manage')
            || Vue.prototype.$auth.hasPermission('owner.manage')
    }

    sidebarTraining() {
        return Vue.prototype.$auth.hasPermission('competency.manage')
            || Vue.prototype.$auth.hasPermission('grid.manage')
            || Vue.prototype.$auth.hasPermission('degree.manage')
            || Vue.prototype.$auth.hasPermission('registration.manage')
    }

    sidebarSettings() {
        return Vue.prototype.$auth.hasOnePermission(['xapi-extra.observe', 'xapi-extra.manage'])
    }

    offlineDashboard() {
        return Vue.prototype.$auth.hasOnePermission([
            'dashboard.access-instructor-dashboard',
            'dashboard.access-pilot-dashboard',
        ])
    }

    // Some usefull functions for our Vue Router.

    redirectToHome(to, from, next) {
        Vue.prototype.$auth.getMe(to, from, next)
        .then(() => {

            // Offline home.
            if (Vue.prototype.$auth.offline) {
                if (Vue.prototype.$permissions.offlineDashboard()) {
                    next({ name: 'offline-dashboard' });
                } else {
                    next({ name: 'offline-disabled' });
                }
                return
            }

            // Online home.
            if (Vue.prototype.$auth.hasOnePermission([
                'dashboard.access-instructor-dashboard',
                'dashboard.access-internal-observer-dashboard',
                'dashboard.access-restricted-internal-observer-dashboard',
                'dashboard.access-external-observer-dashboard',
                'dashboard.access-learner-dashboard',
            ])) {
                next({ name: 'dashboard-sessions' });
            } else if (Vue.prototype.$auth.hasPermission('dashboard.access-pilot-dashboard')) {
                next({ name: 'dashboard-logs' });
            } else if (Vue.prototype.$auth.hasPermission('dashboard.access-issues-from-dashboard')) {
                next({ name: 'dashboard-issues' });
            } else {
                next()
            }

        })
        .catch(err => {
            next({ name: err });
        })
    }
}
